<template>
  <div
    class="bill bill_text_color--text"
    :style="{ backgroundImage: branch_watermark }"
  >
    <div
      style="width: 100%; margin-bottom: 8px"
      class="align-center justify-center row-reversable"
    >
      <div
        style="
          flex: 1;
          display: flex;
          font-size: 12px;
          flex-direction: column;
          justify-content: center;
        "
        class="align-start"
      >
        <img
          alt="SO"
          class="bill_logo"
          :src="branch_logo"
          style="width: 2cm; height: auto"
        />
      </div>
      <div style="display: flex; justify-content: center; align-items: center">
        <div class="font-weight-bold" style="text-align: center">
          <div class="font-weight-bold bill_title">{{ branch_fa_name }}</div>
          <div class="font-weight-bold bill_title">{{ LONG_APP_NAME }}</div>
          <div class="font-weight-bold bill_title">
            {{ $t("a2a_transfer_slip") }}
          </div>
        </div>
      </div>
      <div
        style="
          flex: 1;
          display: flex;
          font-size: 12px;
          flex-direction: column;
          justify-content: center;
        "
        class="align-end"
      >
        <span>
          <span class="pcf-label">{{ $t("tr") }}: </span>
          <span class="pcf-text">
            {{
              transfer.number || (system && system.last_form_number + 1)
            }}</span
          >
        </span>
        <span>
          <span class="pcf-label">{{ $t("date") }}: </span>
          <span class="pcf-text">{{ transfer.date }} {{ transfer.time }}</span>
        </span>
        <span>
          <span class="pcf-label">{{ $t("persian_date") }}: </span>
          <span class="pcf-text">{{
            transfer.date | persianDateFilter(true)
          }}</span>
        </span>
      </div>
    </div>

    <table class="greyGridTable bill-table mb-5">
      <tbody class="lr--text">
        <tr>
          <td
            class="bill_color white--text lr--text"
            style="font-size: 13px; font-weight: 500"
          >
            <span class="pcf-label">
              {{ $t("id") }}
            </span>
          </td>
          <td
            class="bill_color white--text lr--text"
            style="font-size: 13px; font-weight: 500"
          >
            <span class="pcf-label">
              {{ $t("sender_account") }}
            </span>
          </td>
          <td
            class="bill_color white--text lr--text"
            style="font-size: 13px; font-weight: 500"
          >
            <span class="pcf-label">
              {{ $t("receiver_account") }}
            </span>
          </td>
          <td
            class="bill_color white--text lr--text"
            style="font-size: 13px; font-weight: 500"
          >
            <span class="pcf-label">
              {{ $t("amount") }}
            </span>
          </td>
          <td
            class="bill_color white--text lr--text"
            style="font-size: 13px; font-weight: 500"
          >
            <span class="pcf-label">
              {{ $t("currency") }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="mx-2 pcf-text"> {{ transfer.id }}</span>
          </td>
          <td>
            <span class="mx-2 pcf-text"> {{ sender && sender.name }}</span>
          </td>
          <td>
            <span class="mx-2 pcf-text"> {{ receiver && receiver.name }}</span>
          </td>
          <td>
            <span class="mx-2 pcf-text">
              {{ transfer.amount | currency }}
            </span>
          </td>
          <td>
            <span class="mx-2 pcf-text">
              {{ smbl(transfer.currency_id, isRTL) }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="100%">
            <span class="pcf-label">{{ $t("amount_in_word") }}: </span>
            <span class="pcf-text" style="text-transform: capitalize"
              >{{ transfer.amount | toWord }}
              {{ smbl(transfer.currency_id, isRTL) }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="100%">
            <span class="pcf-label">{{ $t("description") }}: </span>
            <span class="pcf-text" style="text-transform: capitalize"
              >{{ transfer.description }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <bill-footer :userProp="transfer.user"></bill-footer>
  </div>
</template>
<script>
export default {
  name: "bill-transfer",
  props: {
    transfer: { default: () => {} },
    receiver: { default: () => {} },
    sender: { default: () => {} },
    system: { default: () => {} },
  },
  computed: {
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    },
  },
};
</script>